<template>
    <v-card v-model="valid" lazy-validation class="overflow-hidden" height="65vh"  outlined style="border:white; position:relative;" fluid color="#000000">
        <v-img :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'system_winner_bg')?.value ?? null)" style="position:absolute;" height="inherit" position="center center"></v-img>
        <!-- <v-card-text> -->
            <v-row ref="scrollRow" class="d-flex justify-content-center position-absolute">
                <v-col cols="12" sm="12" md="12" lg="12" class="d-flex justify-center align-center">
                    {{actions}}
                    <v-container>
                        <v-row no-gutters>
                            <v-col cols="12" class="text-center">
                                <span class="congrats" style="font-size:50px; font-family: Andina;">Congratulations </span>
                                    <h3 style="background: white !important; -webkit-background-clip: text; margin-left: 10%;">To Our Raffle Draw </h3> 
                                <h1 style="font-size:70px;">
                                    Winner!
                                </h1>
                            </v-col>
                            <!-- <v-col class="text-center text-white">
                                <h5>{{ formatDate(data.birth_date) }}</h5>
                            </v-col> -->
                            <v-col cols="12" class="text-center text-white">
                                <v-row v-if="form.suspense_animate == 0">
                                    <v-img :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'system_ticket_image')?.value ?? null)" height="120" class="d-flex" contain>
                                        <v-row no-gutters class="d-flex justify-content-center align-items-center mt-5">
                                            <v-col cols="1" v-for="(text, index) in form.refSuspense" :key="index" class="pa-0 ml-0">
                                                <v-expand-transition>
                                                    <div
                                                        style="position: relative; height: 100px; width: 100px;"
                                                    >
                                                        <span
                                                            style="
                                                                font-size: 70px;
                                                                color: #c99b00;
                                                                font-family: var(--system_yourapp_font_style);
                                                                position: absolute;
                                                                top: 48%;
                                                                left: 50%;
                                                                transform: translate(-50%, -50%);
                                                                text-align: center;
                                                            "
                                                            class="text-font-h4"
                                                        >
                                                            {{ text.number }}
                                                        </span>
                                                    </div>
                                                </v-expand-transition>
                                            </v-col>
                                        </v-row>
                                    </v-img>
                                    <!-- <v-col cols="12" class="text-center text-white">
                                        <v-img :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'system_ticket_image')?.value ?? null)" height="100" class="text-center"  contain position="center center">
                                            <h1 style="font-size:70px;" class="refNum" >{{ form.refNumber }}</h1>
                                        </v-img>
                                    </v-col> -->
                                </v-row>
                                <v-img :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'system_ticket_image')?.value ?? null)" height="150" class="d-flex" contain v-else>
                                    <v-row no-gutters class="d-flex justify-content-center align-items-center mt-5">
                                        <v-col cols="1" v-for="(text, index) in form.refSuspense" :key="index" class="pt-10 ml-1">
                                            <v-img
                                                v-if="!text.shown"
                                                :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'system_suspense_image')?.value ?? null)"
                                                height="70"
                                                width="70"
                                                style="cursor: pointer"
                                                @click="setShow(index)"
                                            ></v-img>
                                            <v-expand-transition>
                                                <div
                                                    v-if="text.shown"
                                                    style="position: relative; height: 70px; width: 70px;"
                                                >
                                                    <v-img
                                                        :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'ticket_image_number_reveal')?.value ?? null)"
                                                        height="70"
                                                        width="70"
                                                    ></v-img>
                                                    <span
                                                        style="
                                                            font-size: 70px;
                                                            color: #c99b00;
                                                            font-family: var(--system_yourapp_font_style);
                                                            position: absolute;
                                                            top: 48%;
                                                            left: 50%;
                                                            transform: translate(-50%, -50%);
                                                            text-align: center;
                                                        "
                                                        class="text-font-h4"
                                                    >
                                                        {{ text.number }}
                                                    </span>
                                                </div>
                                            </v-expand-transition>
                                        </v-col>
                                    </v-row>
                                </v-img>
                                <v-img :src="checkImagePathLogo(GET_PREFERENCES.find(x => x.parameter == 'ticket_image_department')?.value ?? null)" height="146" class="d-flex mt-5" contain style="position: relative;">
                                    <v-expand-transition>
                                        <div v-if="allShown" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; display: flex; flex-direction: column; justify-content: flex-start; align-items: center; padding: 20px; padding-top: 50px;">
                                            <div 
                                                :style="{
                                                    textAlign: 'center',
                                                    fontSize: nameFontSize,
                                                    color: '#c99b00',
                                                    fontFamily: 'var(--system_yourapp_font_style)',
                                                    lineHeight: '1.2',
                                                    wordWrap: 'break-word',
                                                    maxWidth: '90%',
                                                    marginBottom: '15px'
                                                }"
                                            >
                                                {{ form.full_name }}
                                            </div>
                                            <div 
                                                :style="{
                                                    textAlign: 'center',
                                                    fontSize: departmentFontSize,
                                                    color: '#c99b00',
                                                    fontFamily: 'var(--system_yourapp_font_style)',
                                                    lineHeight: '1.2',
                                                    wordWrap: 'break-word',
                                                    maxWidth: '90%'
                                                }"
                                            >
                                                {{ form.company }}
                                            </div>
                                        </div>
                                    </v-expand-transition>
                                </v-img>
                            </v-col>
                            <v-expand-transition>
                                <v-col cols="12" class="text-center text-white" v-if="allShown">
                                    <!-- <h2 style="font-size:40px;"> from {{ form.company }}
                                    </h2> -->
                                </v-col>
                            </v-expand-transition>
                        </v-row>
                    </v-container>
                </v-col>
            </v-row>
        <!-- </v-card-text> -->
        <!-- <v-btn color="#000000">
            <span style="color:#ffa500">
                next
            </span>
        </v-btn> -->
        
    </v-card>
</template>
<script>
import Swal from "sweetalert2";
import { mapGetters } from "vuex";
import confetti from "canvas-confetti";

export default {
    data() {
        return {
            valid: false,
            overlay: false,
            disabled_view: false,
            errors: {
                required: [(v) => !!v || "Field is required"],
                number: [
                    (v) => !!v || "Cost is required",
                    (v) => !isNaN(v) || "Input must be a number",
                ],
            },
            form: {},
            isHover: false,
            allShown: false
        };
    },
    computed: {
        ...mapGetters(['GET_PARTICIPANT_LIST', 'GET_EVENT_ID', 'DIALOGS','GET_PREFERENCES',"GET_EVENT_NAME",'GET_NEW_MASTER_DATA','ACTION','GET_DIALOG_VIEW']),
        actions() {
            this.getRafflePrizeData();
            return ""
        },
        // dynamicGradient() {
        //     return {
        //         background: `-webkit-linear-gradient(var(--system_raffle_winner_text_color), var(--system_raffle_winner_text_color_two))`,
        //         '-webkit-background-clip': 'text',
        //         '-webkit-text-fill-color': 'transparent'
        //     };
        //     },
        refNumberLength() {
        return this.form.refNumber.length * 30;
        },
        companyLength() {
        return this.form.company.length ;
        },
        refNumberFontSize() {
        return `${Math.max(72 - this.refNumberLength * 2, 24)}px`; // Adjust the size based on length
        },
        refNumberImageHeight() {
        return `${Math.max( this.refNumberLength * 2, 100)}px`; // Adjust height based on length
        },
        companyImageHeight() {
        return `${Math.max(this.companyLength * 2, 100)}px`; // Adjust height based on length
        },
        nameFontSize() {
            if (!this.form.full_name) return '32px';
            const nameLength = this.form.full_name.length;
            // Base font size decreases as name gets longer
            // Max width assumption: ~500px for the image
            // Average character width at 32px: ~18px
            const maxChars = 28; // Approximate max characters that fit
            if (nameLength <= 15) return '32px';
            if (nameLength <= 20) return '28px';
            if (nameLength <= 25) return '24px';
            if (nameLength <= 30) return '20px';
            return '18px'; // Minimum font size
        },
        departmentFontSize() {
            if (!this.form.company) return '28px';
            const companyLength = this.form.company.length;
            if (companyLength <= 10) return '28px';
            if (companyLength <= 20) return '24px';
            if (companyLength <= 30) return '20px';
            return '16px';
        }
    },
    created() {
        this.initialForm();
    },
    mounted() {
         window.addEventListener('keyup', this.handleKeyPress);
    },
    destroyed() {
        window.removeEventListener('keyup', this.handleKeyPress);
    },
    methods: {
        checkImagePathLogo(image_path) {
            return process.env.VUE_APP_API_HOST + "/" + image_path
        },
        initialForm() {
            this.form = {
                code          : '',
                name          : '',
                order         : '',
                prize_image   : '',
                department    : '',
                full_name     : '',
                company       : '',
                refNumber     : '',
                data_grouping : null,
            };
        },
        closeDialog() {
            this.$store.commit("DIALOG", false);
        },
        async getRafflePrizeData() {
            Object.assign(this.form, this.GET_DIALOG_VIEW)
            // if(this.GET_DIALOG_VIEW.suspense_animate){
            if(this.form.refNumber){
                this.form.refSuspense = this.form.refNumber.split('');
                this.form.refSuspense = this.form.refSuspense.map((x)=>{
                    return {
                        number: x,
                        shown: 0
                    }
                })
            }
            if(this.form.suspense_animate == 0){
                this.allShown = true;
                this.confetti();
            }
            // }
        },
        setShow(i){
            if (this.form.refSuspense[i] !== undefined) {
                this.form.refSuspense[i].shown = !this.form.refSuspense[i].shown;
                let shownCount = this.form.refSuspense.filter(x=>x.shown == 1).length;
                if(shownCount == this.form.refSuspense.length){
                    this.confetti();
                    this.allShown = true;
                }
                this.$forceUpdate();
            } 
        },
        confetti() {
            let duration = 15 * 1000,
                animationEnd = Date.now() + duration,
                defaults = {
                startVelocity: 20,
                spread: 360,
                ticks: 90,
                zIndex: 9999,
            };
            let interval = setInterval(function () {
                let timeLeft = animationEnd - Date.now();

                if (timeLeft <= 0) {
                    return clearInterval(interval);
                }

                let particleCount = 80 * (timeLeft / duration);
                function randomInRange(min, max) {
                    return Math.random() * (max - min) + min;
                }
                const confettiColor1 = getComputedStyle(document.documentElement).getPropertyValue('--system_raffle_confetti_color').trim();
                const confettiColor2 = getComputedStyle(document.documentElement).getPropertyValue('--system_raffle_confetti_color_two').trim();

                // since particles fall down, start a bit higher than random
                confetti(
                    Object.assign({}, defaults, {
                        particleCount: 300,
                        colors: [confettiColor1, confettiColor2],
                        shapes: ['circle', 'circle', 'square'],
                        origin: {
                            x: randomInRange(0.1, 0.3),
                            y: Math.random() - 0.2,
                        },
                    })
                );
                confetti(
                    Object.assign({}, defaults, {
                        particleCount: 300,
                        colors: [confettiColor1, confettiColor2],
                        shapes: ['circle', 'circle', 'square'],
                        origin: {
                            x: randomInRange(0.7, 0.9),
                            y: Math.random() - 0.2,
                        },
                    })
                );
            }, 250);
		},
        handleKeyPress(event) {
            if(this.form.suspense_animate){
                if(!isNaN(event.key)){
                    this.setShow(event.key - 1)
                }
            }
        }
    },
    watch: {
        DIALOGS: {
            handler(val) {
                if (!val) {
                    this.initialForm();
                    this.$store.commit('DIALOG_VIEW', {})
                    this.allShown = false;
                }
            },
          
        },
    },
};
</script>
<style scoped>
    /* .root{
        --system_raffle_winner_text_color:#f69f1a;
        --system_raffle_winner_text_color_two:#f61f1a;
        --system_raffle_suspense_card_color:#c8f309;
        --system_raffle_suspense_card_color_two:#00aaff;
        --system_raffle_suspense_card_color_three:#f200ff;
    }
     */
    .modal_title {
        position: sticky;
        top: 0;
        z-index: 10;
        background-color: white;
    }
    h4 ,h1 , h5, h2, .congrats {
        font-family: var(--system_yourapp_font_style);
        background: -webkit-linear-gradient(var(--system_raffle_winner_text_color), var(--system_raffle_winner_text_color_two));
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }   

    .myclass.v-sheet.v-card {
        border: 3px solid #ffa500 !important;
    }

    .gradient_card {
        
        background: -webkit-linear-gradient(var(--system_raffle_suspense_card_color), var(--system_raffle_suspense_card_color_two), var(--system_raffle_suspense_card_color_three));
    }

    .fade-enter-active, .fade-leave-active,
    .slide-fade-enter-active, .slide-fade-leave-active {
        transition: opacity 0.5s, transform 0.5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .slide-fade-enter, .slide-fade-leave-to {
        opacity: 0;
        transform: translateY(-20px);
    }

    .image-container {
  position: relative;
  width: 100%;
  height: 100%;
}

.cover-image {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}
</style>
